import React, { useState } from "react";
import Editor from "@monaco-editor/react";

type ResponseModelProps = {
  input: string;
  setInput: (val: string) => void;
};

const ResponseModel: React.FC<ResponseModelProps> = ({ input, setInput }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(input);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
     
        {/* Monaco Editor */}
        <Editor
          height="300px"
          defaultLanguage="json"
          value={input}
          onChange={(value) => setInput(value || "")}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 14,
            formatOnPaste: true,
            formatOnType: true,
          }}
        />
      </>
  );
};

export default ResponseModel;
